export const CLEANING_TYPES = {
    standard: 'standartnaya-uborka',
    general: 'generalnaya-uborka',
    renovation: 'uborka-doma-posle-remonta',
}

export const CLEANING_PRICES = {
    [CLEANING_TYPES.standard]: '12750',
    [CLEANING_TYPES.general]: '27119',
    [CLEANING_TYPES.renovation]: '43500',
}

export const BCC_CLEANING_PRICES_APARTMENT = {
    [CLEANING_TYPES.standard]: '15540',
    [CLEANING_TYPES.general]: '40002',
    [CLEANING_TYPES.renovation]: '58586',
}

export const BCC_CLEANING_PRICES_HOUSE = {
    [CLEANING_TYPES.standard]: '24240',
    [CLEANING_TYPES.general]: '52520',
    [CLEANING_TYPES.renovation]: '83148',
}